import React from 'react';

import Seo from '../../uglib_components/seo'

import SidebarLayout from '../../uglib_components/sidebarLayout'

import FAQIndex from '../../uglib_components/FAQIndex';
import FAQList from '../../uglib_components/FAQList';

import Sidebar from '../../uglib_components/sidebar';
import SidebarMenu from '../../uglib_components/sidebarMenu';

const FAQPage = ({ location }) => {
    const breadcrumbs = [
		{ 
			url: "",
			title: "Using the Library",
		}
	]

    let sidebar = <>
        <Sidebar>
            <SidebarMenu url={location.pathname}/>
        </Sidebar>
    </>;

    return (
        <SidebarLayout title="Frequently Asked Questions" sidebar={sidebar} breadcrumbs={breadcrumbs}>
            <Seo title="FAQs" keywords={[]} />
            <FAQIndex category="General" />
            <FAQList category="General" />
        </SidebarLayout>
    )
}

export default FAQPage
